import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output,
  ViewEncapsulation
} from '@angular/core';
import { ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { DeviceService, ISdFormComponentItem, SdBorderWrapperComponent, SdFormRadioGroupComponent, SdTitleComponent } from '@seb/web-design-system/core';

import type { IPaymentMethods } from './payment-methods.interface';

@Component({
  selector: 'sd-payment-methods',
  templateUrl: './payment-methods.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  styleUrls: ['./payment-methods.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdBorderWrapperComponent,
    SdFormRadioGroupComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SdTitleComponent
  ]
})
export class SdPaymentMethodsComponent implements OnInit, OnDestroy {
  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly deviceService: DeviceService,
  ) {}

  selectAdyenPayment = false;
  mobileSubscription: Subscription;
  isMobile$: boolean;

  @Input()
  paymentMethods: IPaymentMethods;

  @Input()
  titleLevel = 4;

  @Output()
  changedPayment = new EventEmitter<ISdFormComponentItem>();

  @Input()
  set selectAdyen(value: boolean) {
    this.selectAdyenPayment = value;
  }

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  changePayment(item: ISdFormComponentItem) {
    this.changedPayment.emit(item);
  }
}
